import { GenericReturnType, handleFirebaseError } from "src/store";
import { functions } from ".";
import { httpsCallable } from "firebase/functions";

export const callFunctionSafe = async <X, T = any>(functionName: string, payload: T): Promise<GenericReturnType<X>> => {
  try {
    const callable = httpsCallable(functions, functionName);

    const result = await callable(payload);

    return { data: result.data as X };
  } catch (error) {
    console.log(error);
    throw handleFirebaseError(error);
  }
};
